import { Reducer } from 'redux'
import { createFilter } from 'redux-persist-transform-filter'

import { ConferencesActionTypes, ConferencesState } from './types'

export const FILTER_PERSISTOR = createFilter(
  'conferences',
  null,
  ['filterStatus'],
  'whitelist'
)

const INITIAL_STATE: ConferencesState = {
  error: '',
  filterStatus: [],
  list: [],
  loading: false,
  setStatusError: '',
  setStatusLoading: false,
  setStatusSuccess: '',
  total_results: 0
}

const reducer: Reducer<ConferencesState> = (
  state = INITIAL_STATE,
  { payload, type }
) => {
  switch (type) {
    /**
     * GET_CONFERENCE
     */
    case ConferencesActionTypes.GET_CONFERENCES:
      return {
        ...state,
        error: '',
        filterStatus: payload.options.filterStatus,
        loading: true,
        setStatusError: ''
      }
    case ConferencesActionTypes.GET_CONFERENCES_SUCCESS:
      return {
        ...state,
        list: payload.list,
        loading: false,
        total_results: payload.total_results
      }
    case ConferencesActionTypes.GET_CONFERENCES_FAILURE:
      return {
        ...state,
        error: payload.message,
        loading: false
      }

    /**
     * SET_CONFERENCE_STATUS
     */
    case ConferencesActionTypes.SET_CONFERENCE_STATUS:
      return {
        ...state,
        setStatusError: '',
        setStatusLoading: true,
        setStatusSuccess: ''
      }
    case ConferencesActionTypes.SET_CONFERENCE_STATUS_SUCCESS:
      return {
        ...state,
        setStatusLoading: false,
        setStatusSuccess: payload.message
      }
    case ConferencesActionTypes.SET_CONFERENCE_STATUS_FAILURE:
      return {
        ...state,
        setStatusError: payload.message,
        setStatusLoading: false
      }

    default:
      return state
  }
}

export default reducer
